import { render, staticRenderFns } from "./registerDialog.vue?vue&type=template&id=66426af7&scoped=true"
import script from "./registerDialog.vue?vue&type=script&lang=js"
export * from "./registerDialog.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=66426af7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66426af7",
  null
  
)

export default component.exports